import React from 'react'
import {useSolv} from "../components/SolvProvider"
import MainMenu from "../MainMenu.js"
import {ActionButton, FormBody, FormHeader, MainContainer, useAlert} from "../components/FormComps.js"
import {useIntlEx} from "../components/IntlUtils"
import {DataTable, useCols} from "../components/TableComps"
import getLogger from "../components/Logging.js"
import {TagLabel} from "../components/TagBox";
import '../App.css'

const log = getLogger("BankAccounts")

export default function BankAccounts() {

  const {api, session: {user, tenant}, setBusy} = useSolv()
  const {intl } = useIntlEx()

  const [alert, setAlert] = useAlert(null)

  const {cols} = useCols({
    resourceName: "bankAccounts",
    specs: [
      {
        field: "bankAccountNo",
        label: intl.msg("bank_account_no"),
        filter: "text",
        sort: "ASC",
        align: "left",
      },
      {
        field: "bankAccountName",
        label: intl.msg("bank_account_name"),
        filter: "text",
        sort: "",
        align: "left",
      },
      {
        field: "currencyCode",
        label: intl.msg("currency"),
        filter: {
          type: "asyncselect",
          loader: (input, loadedOptions, additional) => {
            // log.debug("listRegions: invoked")
            return api.listCurrencies({view: "BASIC", extraParams: `${input ? `filter=displayName:${encodeURIComponent(input)}&` : ""}sort=currencyName:ASC`, cursor: additional?.cursor, limit: 20})
              .then(({data, nextCursor}) => {
                let opt = data.map(c => {
                  return {
                    value: c.currencyCode,
                    label: c.displayName || c.currencyName,
                  };
                });
                let res = {
                  options: opt,
                }
                if (nextCursor) {
                  res = {
                    ...res,
                    hasMore: true,
                    additional: {
                      cursor: nextCursor
                    }
                  }
                }
                // log.debug("loadRegions: res=", res)
                return res
              });
          },
          multi: true,
        },
        sort: "",
        align: "left",
      },
    ],
  })

  function handleFetchDataPage({pageParam: cursor}) {
    return api.listBankAccounts({extraParams: cols.stringify(), cursor: cursor})
  }

  function handleRenderDataCol(col, row) {
    let n
    switch (col.field) {
      case "bankAccountNo":
        n = row.bankAccountNo
        break
      case "bankAccountName":
        n = <div className="d-flex align-items-center gap-1">
              <span>
                {row.bankAccountName}
              </span>
              <span>
                {row.primary === true ? <TagLabel label={intl.msg("primary")} size="md"/> : ""}
              </span>
            </div>
        break
      case "currencyCode":
        n = <a className="text-link" href={`/sys/currencies?filter=currencyCode${encodeURIComponent(`:=${row.currencyCode}`)}`}>{row.currencyDisplayName}</a>
        break
    }
    return (
        n
    )
  }

  function handleRowClick(row) {
    window.location = `/sys/bankaccounts/${row.bankAccountId}`
  }

  function handleError(error) {
    if (error) {
      // log.debug("handleError: error=", JSON.stringify(error))
      if (error.code) {
        switch (error.code) {
          case "BAD_PAYLOAD":
            if (error.msg) {
              setAlert({type: "error", text: error.msg})
            }
            else {
              setAlert({type: "error", text: intl.msg("error_failed")})
            }
            break
          case "UNKNOWN_LOCATION":
            // log.debug("ERROR: ", error)
            if (error.msg) {
              setAlert({type: "error", text: error.msg})
            }
            else {
              setAlert({type: "error", text: intl.msg("error_failed")})
            }
            break
          default:
            setAlert({type: "error", text: intl.msg("error_failed")})
        }
      }
      else {
        setAlert({type: "error", text: intl.msg("error_failed")})
      }
    }
  }

  async function handleExport() {
    return await api.exportLocations({extraParams: cols.stringify()})
  }

  return (
    tenant &&
      <>

        <MainContainer tenant={tenant} menu={MainMenu} allowIfAccessingAs={"*/*/SYSTEM"}>

          <FormHeader>
            <FormHeader.Toolbar>
              <FormHeader.Toolbar.Title>
                {intl.msg("bank_accounts_title")}
              </FormHeader.Toolbar.Title>
              <FormHeader.Toolbar.Controls>
                {
                  user.isSystem() && user.isManagerOrAbove() &&
                    <ActionButton name="add_new" flavor="primary"  href={`/sys/bankaccounts/_new`}/>
                }

              </FormHeader.Toolbar.Controls>
            </FormHeader.Toolbar>
            <FormHeader.Alert alert={alert}/>
          </FormHeader>
          <FormBody>
            <DataTable
              tenant={tenant}
                cols={cols}
                resourceName="bankAccounts"
                dataKey="bankAccountId"
                onFetchDataPage={handleFetchDataPage}
                onRenderDataCol={handleRenderDataCol}
                onClickDataRow={handleRowClick}
            />
          </FormBody>
        </MainContainer>

      </>
  )
}